import { Alert, Button } from "reactstrap";
import { useFileDelete } from "./hooks/useFileDelete";

const DeleteFileSection = () => {
  const { deleteButtonClick } = useFileDelete();

  return (
    <Alert color="warning text-center">
      <div className="mb-3">
        Υπάρχει ήδη αρχείο χρεώσεων περασμένο για την συγκεκριμένη ημερομηνία. Πατώντας συνέχεια, συμφωνείτε για την διαγραφή του.
      </div>
      <div>
        <Button color="danger" onClick={deleteButtonClick}>Συνέχεια</Button>
      </div>
    </Alert>
  )
}

export default DeleteFileSection;